module.exports = __webpack_public_path__ + "img/jflogo.80d681e9.png";